import PropTypes from 'prop-types'

import { nombreMedioPago } from '../../../helpers/mediosPago.js'
import { ChipList } from '../../components/index.js'

/**
 * Lista de chips con los medios de pago de una publicación.
 * Los no habilitados se muestran con variante `warning` y el motivo en el tooltip.
 * @param {{ mediosPagos?: Array, title?: string }} props
 */
export const MediosPagoChips = ({ mediosPagos = [], title = 'Medios de Pago' }) => {
  const items = mediosPagos.flatMap((mp) => {
    const label = nombreMedioPago(mp)
    if (!label) return []

    return [
      {
        id: mp.idMedioPago,
        label,
        tooltip: mp.tooltip,
        variant: mp.habilitado ? 'default' : 'warning',
        tooltipSize: 'large'
      }
    ]
  })

  if (items.length === 0) return null

  return <ChipList title={title} items={items} />
}

export const medioPagoPropType = PropTypes.shape({
  idMedioPago: PropTypes.number,
  habilitado: PropTypes.bool,
  tooltip: PropTypes.string,
  nombre: PropTypes.string,
  medioPago: PropTypes.shape({
    nombre: PropTypes.string
  })
})

MediosPagoChips.propTypes = {
  mediosPagos: PropTypes.arrayOf(medioPagoPropType),
  title: PropTypes.string
}
